'use client';

import React, { useEffect, useRef } from "react";
import { ContentfulComponentProps } from "../type";

export default function StickyCtaTrigger({ asset }:ContentfulComponentProps<SiteStickyCta>) : React.JSX.Element {
    const triggerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        let lastScroll = 0;

        function scrollHandler() {
            const top = triggerRef?.current?.getBoundingClientRect()?.top;
            const dir = lastScroll < window.scrollY ? 'down' : 'up';
            lastScroll = window.scrollY;

            const scrollPosition = window.innerHeight + window.scrollY;
            const bottomPosition = document.body.offsetHeight - 100;

            if (scrollPosition >= bottomPosition) {
                document.body.classList.remove('stickyBarStick');
                return;
            }

            if((asset.fields.presentation.styles['Scroll-up Behavior'] === 'Global Nav') && (dir === 'up')) {
                document.body.classList.remove('stickyBarStick');
            } else if(top !== undefined) {
                if(top <= -1) {
                    document.body.classList.add('stickyBarStick');
                } else {
                    document.body.classList.remove('stickyBarStick');
                }
            }
        }

        document.addEventListener('scroll', scrollHandler);
        return () => document.removeEventListener('scroll', scrollHandler);
    }, [asset.fields.presentation.styles]);

    return <div ref={triggerRef} data-note='sticky-trigger'></div>
}